<template >
  <div
      class="answers_wrap"
      v-if="answer" >
    <!--    ==={{ answer }}-->
    <h1 class="padding_15" >For your health and safety</h1 >
    <h2 class="padding_15" >Before finalising your booking it is important to provide us information about the
                            participants</h2 >
    <h4 class="padding_15" >Client Questionnaire for person number
                            {{ ($route.query.person ? $route.query.person * 1 : 0) + 1 }}</h4 >
    <p class="flex customer_info" >
      <span >Full name</span >
      <span ><input
          type="text"
          v-model="answer.fullName"
          name="name" /></span >
    </p >
    <p class="flex customer_info" >
      <span >Passport Number</span >
      <span ><input
          type="text"
          v-model="answer.passport"
          name="name" /></span >
    </p >
    <!--    <p class="flex customer_info" >-->
    <!--      <span >Date</span >-->
    <!--      <span ><input-->
    <!--          type="date"-->
    <!--          name="date" /></span >-->
    <!--    </p >-->
    <p class="flex customer_info" >
      <span >*Date of Birth</span >
      <span ><input
          type="date"
          v-model="answer.birthDate"
          name="birth_date" /></span >
    </p >
    <p class="flex customer_info" >
      <span >*Height (meters)</span >
      <span > <q-input
          v-model.number="answer.height"
          type="number"
          filled
          style="max-width: 200px" /></span >
    </p >
    <p class="flex customer_info" >
      <span >*Weight (kilos)</span >
      <span > <q-input
          v-model.number="answer.weight"
          type="number"
          filled
          style="max-width: 200px" /></span >
    </p >
    <p class="flex customer_info" >
      <span >*Nationality</span >
      <span ><input
          type="text"
          v-model="answer.nationality"
          name="nationality" /></span >
    </p >
    <!--    <p class="flex customer_info" >-->
    <!--      <span >*Date of Birth</span >-->
    <!--      <span ><input-->
    <!--          type="date"-->
    <!--          v-model="answer.birthDate"-->
    <!--          name="birth_date" /></span >-->
    <!--    </p >-->
    <p class="flex customer_info" >
      <span >Home address</span >
      <span ><input
          type="text"
          v-model="answer.homeAddress"
          name="address" /></span >
    </p >
    <!--    <p class="flex customer_info" >-->
    <!--      <span >Contact Number</span >-->
    <!--      <span ><input-->
    <!--          type="text"-->
    <!--          name="phone" /></span >-->
    <!--    </p >-->
    <p class="flex customer_info" >
      <span >Emergency Contact Number</span >
      <span ><input
          type="text"
          v-model="answer.phoneEmergency"
          name="emergency_phone" /></span >
    </p >
    <!--    <p class="flex customer_info" >-->
    <!--      <span >Email</span >-->
    <!--      <span ><input-->
    <!--          type="email"-->
    <!--          name="email" /></span >-->
    <!--    </p >-->
    <p class="padding_15" >
      Sea Kayaking can be a physically demanding sport, taking place in remote areas beyond the immediate reach of
      emergency services. Please help your guide-coach to keep you safe by answering the following questions. Please
      note that declaring a medical condition will not, in most cases, prevent you from kayaking. </p >
    <h4 class="padding_15" >This information will be used only by SEA KAYAKING ZAKYNTHOS for a period of 5 years for
                            insurance and liability.</h4 >
    <p class="flex suffer" >
      <span >Please answer with honestly</span >
      <span >YES</span >
      <span >NO</span >
    </p >
    <p class="flex suffer" >
      <span >Can you swim over 25m?</span >
      <span ><input
          type="checkbox"
          name="swim"
          :checked="answer.swim_over_25m"
          @input="$set(answer,'swim_over_25m',true)" /></span >
      <span ><input
          type="checkbox"
          name="swim"
          :checked="answer.swim_over_25m!==undefined&&!answer.swim_over_25m"
          @input="$set(answer,'swim_over_25m',false)" /></span >
    </p >
    <p class="flex suffer" >
      <span >Do you hold any current first aid Qualification?</span >
      <span ><input
          type="checkbox"
          name="aid"
          :checked="answer.first_aid_Qualification"
          @input="$set(answer,'first_aid_Qualification',true)" /></span >
      <span ><input
          type="checkbox"
          name="aid"
          :checked="answer.first_aid_Qualification!==undefined&&!answer.first_aid_Qualification"
          @input="$set(answer,'first_aid_Qualification',false)" /></span >
    </p >
    <p class="flex suffer" >
      <span >Do you suffer from, or have a history of the following conditions:</span >
      <span >YES</span >
      <span >NO</span >
    </p >
    <p class="flex suffer" >
      <span >Sea Sickness</span >
      <span ><input
          type="checkbox"
          name="Sickness"
          :checked="answer.sea_Sickness"
          @input="$set(answer,'sea_Sickness',true)" /></span >
      <span ><input
          type="checkbox"
          name="Sickness"
          :checked="answer.sea_Sickness!==undefined&&!answer.sea_Sickness"
          @input="$set(answer,'sea_Sickness',false)" /></span >
    </p >
    <p class="flex suffer" >
      <span >Allergies</span >
      <span ><input
          type="checkbox"
          name="Allergies"
          :checked="answer.Allergies"
          @input="$set(answer,'Allergies',true)" /></span >
      <span ><input
          type="checkbox"
          name="Allergies"
          :checked="answer.Allergies!==undefined&&!answer.Allergies"
          @input="$set(answer,'Allergies',false)" /></span >
    </p >
    <p class="flex suffer" >
      <span >Asthma</span >
      <span ><input
          type="checkbox"
          name="Asthma"
          :checked="answer.Asthma"
          @input="$set(answer,'Asthma',true)" /></span >
      <span ><input
          type="checkbox"
          name="Allergies"
          :checked="answer.Asthma!==undefined&&!answer.Asthma"
          @input="$set(answer,'Asthma',false)" /></span >
    </p >
    <p class="flex suffer" >
      <span >Epilepsy</span >
      <span ><input
          type="checkbox"
          name="Epilepsy"
          :checked="answer.Epilepsy"
          @input="$set(answer,'Epilepsy',true)" /></span >
      <span ><input
          type="checkbox"
          name="Epilepsy"
          :checked="answer.Epilepsy!==undefined&&!answer.Epilepsy"
          @input="$set(answer,'Epilepsy',false)" /></span >
    </p >
    <p class="flex suffer" >
      <span >Diabetes</span >
      <span ><input
          type="checkbox"
          name="Diabetes"
          :checked="answer.Diabetes"
          @input="$set(answer,'Diabetes',true)" /></span >
      <span ><input
          type="checkbox"
          name="Epilepsy"
          :checked="answer.Diabetes!==undefined&&!answer.Diabetes"
          @input="$set(answer,'Diabetes',false)" /></span >
    </p >
    <p class="flex suffer" >
      <span >Heart Problems</span >
      <span ><input
          type="checkbox"
          name="heartProblems"
          :checked="answer.heartProblems"
          @input="$set(answer,'heartProblems',true)" /></span >
      <span ><input
          type="checkbox"
          name="Epilepsy"
          :checked="answer.heartProblems!==undefined&&!answer.heartProblems"
          @input="$set(answer,'heartProblems',false)" /></span >
    </p >
    <p class="flex suffer" >
      <span >Back, Shoulder or Neck pain</span >
      <span ><input
          type="checkbox"
          name="Back_Shoulder_or_Neck_pain"
          :checked="answer.Back_Shoulder_or_Neck_pain"
          @input="$set(answer,'Back_Shoulder_or_Neck_pain',true)" /></span >
      <span ><input
          type="checkbox"
          name="Back_Shoulder_or_Neck_pain"
          :checked="answer.Back_Shoulder_or_Neck_pain!==undefined&&!answer.Back_Shoulder_or_Neck_pain"
          @input="$set(answer,'Back_Shoulder_or_Neck_pain',false)" /></span >
    </p >
    <p class="flex suffer" >
      <span >Osteoporosis ore bone condition</span >
      <span ><input
          type="checkbox"
          name="Osteoporosis_ore_bone_condition"
          :checked="answer.Osteoporosis_ore_bone_condition"
          @input="$set(answer,'Osteoporosis_ore_bone_condition',true)" /></span >
      <span ><input
          type="checkbox"
          name="Osteoporosis_ore_bone_condition"
          :checked="answer.Osteoporosis_ore_bone_condition!==undefined&&!answer.Osteoporosis_ore_bone_condition"
          @input="$set(answer,'Osteoporosis_ore_bone_condition',false)" /></span >
    </p >
    <p class="flex suffer" >
      <span >Did you have an operation in the last 6 months?</span >
      <span ><input
          type="checkbox"
          name="operation_last_6_months"
          :checked="answer.operation_last_6_months"
          @input="$set(answer,'operation_last_6_months',true)" /></span >
      <span ><input
          type="checkbox"
          name="operation_last_6_months"
          :checked="answer.operation_last_6_months!==undefined&&!answer.operation_last_6_months"
          @input="$set(answer,'operation_last_6_months',false)" /></span >
    </p >
    <p class="flex suffer" >
      <span >Are you pregnant?</span >
      <span ><input
          type="checkbox"
          name="pregnant"
          :checked="answer.pregnant"
          @input="$set(answer,'pregnant',true)" /></span >
      <span ><input
          type="checkbox"
          name="pregnant"
          :checked="answer.pregnant!==undefined&&!answer.pregnant"
          @input="$set(answer,'pregnant',false)" /></span >
    </p >
    <p class="padding_15" >
      If you answer with YES to any of the above questions please provide further details and management:
      <textarea
          type="text"
          v-model="answer.health_details"
          name="details"
          rows="5" ></textarea >
    </p >
    <h4 class="padding_15" >Important Information:</h4 >
    <p class="padding_15" >
      While our Guides are qualified to administer first aid, they are unable to provide you with any form of
      medication. This includes non prescription pain relief such as Aspirin, Paracetamol etc for use of headaches and
      minor injuries. If you require any form of medication please insure that you will bring it with you. In case of
      important medications such as epipens and inhalers you should also advise the guide of their location. </p >
    <p class="padding_15" >
      I hereby declare that the information given above is to the best of my knowledge, truthful and accurate. I
      understand that kayaking can be a hazardous activity that can, although it is unlikely, result in severe unjury or
      death. Although “SEA KAYAKING ZAKYNTHOS” will take all possible precautions to keep me safe, I understand these
      risks and accept them in order to participate in this activity. If I have any concerns about the health and safety
      of myself or other members of the group I will inform the group leader accordingly. </p >
    <p class="padding_15" >
      I agree that I will take care of any equipment provided by SEA KAYAKING ZAKYNTHOS to prevent damage or loss and in
      case of damaging or loosing the equipment I may be held liable part or full for its repair or replacement. </p >

    <sf-button
        type="primary"
        @click="$emit('input',answer);$emit('back')"
        style="float:left;" >
      <i class="material-icons" >arrow_back</i >
      {{ ($route.query.person ? $route.query.person * 1 : 0) ? 'Previous Person' : 'Booking Details' }}
    </sf-button >
    <sf-button
        v-if="($route.query.person?$route.query.person*1:0)<(personCount-1)"
        type="primary"
        @click="$emit('input',answer);$emit('next')"
        style="float:right;" >
      Next Person<i class="material-icons" >arrow_forward</i >
    </sf-button >
    <sf-button
        v-else
        type="primary"
        @click="$emit('input',answer);$emit('next')"
        style="float:right;" >
      Pay Now<i class="material-icons" >done</i >
    </sf-button >
  </div >
</template >

<script >
export default {
  name: "ExtraInfo",
  props: {
    value: {
      type: Object, default: () => {
      }
    },
    personCount: {type: Number, default: null}
  },
  data() {
    return {
      answer: this.value
    };
  },
}
</script >

<style >

div.answers_wrap {
  max-height: calc(100vh - 220px);

  overflow-y: scroll;
}

div.answers_wrap h1 {
  font-size: 24px;
  padding-bottom: 2px;
  padding-top: 2px;
}

div.answers_wrap h2 {
  font-size: 20px;
  padding-bottom: 2px;
  padding-top: 2px;
}

div.answers_wrap .flex {
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid;
  padding-bottom: 10px;
}

div.answers_wrap .flex SPAN {
  padding: 0px 15px;

}

.customer_info SPAN {
  flex: 1;
}

@media screen and (max-width: 768px) {
  p.flex.suffer > span:first-child {
    width: 100%;
    flex:1 0 100%;
  }

  div.answers_wrap h1 {
    font-size: 20px;
  }

  .customer_info SPAN {
    flex: 1 0 100%;
  }


}


.customer_info SPAN input {
  width: 100%;
}

div.answers_wrap .flex SPAN:nth-child(2) {
  margin-left: auto;
}

div.answers_wrap .flex.suffer SPAN:last-child,
div.answers_wrap .flex.suffer SPAN:nth-child(2) {
  text-align: center;
  width: 50px;
}

div.answers_wrap
TEXTAREA {
  width: 100%;
}

.padding_15 {
  color: #0e5763;
  padding: 0px 15px;
}
</style >
